export default "__VITE_ASSET__DLzHtQRE__"